interface HandleReOrderListProps<T> {
  toIdx: number;
  fromIdx: number;
  list: T[];
}

export const handleReOrderList = <T>({
  list,
  toIdx,
  fromIdx,
}: HandleReOrderListProps<T>) => {
  const newList = [...list];
  const tempElement = newList[fromIdx];
  newList.splice(fromIdx, 1);
  newList.splice(toIdx, 0, tempElement);

  return newList;
};
